import Immutable from 'immutable';
import {
  FLAG_BASE_FUEL_REFILL_ACTIVITY,
  CLEAR_BASE_FUEL_REFILL,
  GET_BASE_FUEL_REFILL,
  FLAG_IS_CIRCUIT_EXTRAORDINARY,
  FLAG_GETTING_BASE_FUEL_REFILLS,
  GET_BASE_FUEL_REFILLS,
  CLEAR_BASE_FUEL_REFILLS,
} from '../../../actions/types/traffic';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  extraordinary: false,
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_BASE_FUEL_REFILLS:
      return state.setIn(['all', 'loading'], payload);
    case GET_BASE_FUEL_REFILLS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_BASE_FUEL_REFILLS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_BASE_FUEL_REFILL_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_BASE_FUEL_REFILL:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_BASE_FUEL_REFILL:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case FLAG_IS_CIRCUIT_EXTRAORDINARY:
      return state.setIn(['extraordinary'], payload);
    default:
      return state;
  }
};
